import CryptoJS from "crypto-js";

const publicKeyText = `-----BEGIN PUBLIC KEY-----
MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAnlWl3GusXqrx38OD1XHG
/YEbnPerxbI5LcFwmrDiJo6cNNzbCYengSNu7O81Yw/1ZLdlMP2XmYs8saW85GOI
6FP6wTmUEE8seJsgTRdUxJbth19E9dmI+8uz3yg66VOny/fLQEXE6mdjANHWTkK+
3b5YArJ+i7Y+29BZH4ZzUBkaVi6Sle+lgQ6e3alesiznTgMKyNq5Eh5RY4FbbLK/
kX+ja1rX/7oZ+Ca+2Mh2G6X4ssr9uDVLJUy1ouZvMOjUTDtYkkLwGv11P7T6/bwS
ZP+5pdfCxAgEO2Zf+a9uefzy7JxoNx75vd+6n+JgYbhzRHnEl80wSVtOFJSwLUN2
6QIDAQAB
-----END PUBLIC KEY-----`;

// PEM → ArrayBuffer
function pemToArrayBuffer(pem) {
  const b64 = pem
    .replace("-----BEGIN PUBLIC KEY-----", "")
    .replace("-----END PUBLIC KEY-----", "")
    .replace(/\s+/g, "");
  const binary = atob(b64);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i++) {
    bytes[i] = binary.charCodeAt(i);
  }
  return bytes.buffer;
}

export async function encryptRSA(json) {
  const aesKey = CryptoJS.lib.WordArray.random(32).toString(); // AES-256 key

  // AES Encrypt payload (unchanged)
  const encryptedPayload = CryptoJS.AES.encrypt(
    JSON.stringify(json),
    aesKey
  ).toString();

  // Import RSA Public Key
  const cryptoKey = await window.crypto.subtle.importKey(
    "spki",
    pemToArrayBuffer(publicKeyText),
    { name: "RSA-OAEP", hash: "SHA-256" },
    false,
    ["encrypt"]
  );

  // RSA-OAEP encrypt AES key
  const encryptedAESKeyBuffer = await window.crypto.subtle.encrypt(
    { name: "RSA-OAEP" },
    cryptoKey,
    new TextEncoder().encode(aesKey)
  );

  const encryptedAESKey = btoa(
    String.fromCharCode(...new Uint8Array(encryptedAESKeyBuffer))
  );

  return {
    key: encryptedAESKey,
    data: encryptedPayload
  };
}